<template>
	<section
		class="stay_in_touch"
		:style="{'--progress': 0}"
	>
		<div class="container">
			<div class='left'>
				<h4>Stay In Touch</h4>
			</div>
			<div class='right'>
				<slot>

				</slot>
			</div>

		</div>

	</section>
</template>

<script>
export default {
	data() {
		return {
			window: {
				width: 0,
				height: 0,
			},
			scrollOpacity: 1,
		};
	},

	props: {},

	computed: {},

	watch: {},

	methods: {
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},
	},

	components: {},

	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', this.handleResize);
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	destroyed() {
		window.removeEventListener('resize', this.handleResize);
		this.handleResize();
	},

	mounted() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
		window.addEventListener('scroll', this.calculateOpacity);
	},

	change() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	beforeDestroy() {
		window.removeEventListener('scroll', this.calculateOpacity);
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.stay_in_touch {
	background: var(--dark-blue);
	position: relative;
	overflow: hidden;
	border-top: 1px solid var(--light-grey);

	.container {
		padding-top: 75px;
		padding-bottom: 75px;

		@media (max-width: $mobile-xl) {
			padding-top: 50px;
			padding-bottom: 50px;
			row-gap: 24px;
		}

		.left {
			grid-column: span 4;

			h4 {
				color: var(--white);
			}

			@media (max-width: $mobile-xl) {
				grid-column: span 4;
			}
		}

		.right {
			grid-column: 5 / span 7;
			color: var(--white);

			@media (max-width: $mobile-xl) {
				grid-column: span 4;
			}

			.description {
				&::v-deep {
					p {
						font-size: 24px;
						line-height: 30px;
						font-weight: 300;
						color: var(--white);

						&:first-of-type {
							margin-top: 0;
						}

						&:last-of-type {
							margin-bottom: 0;
						}

						a {
							font-size: 24px;
							line-height: 30px;
							font-weight: 300;
							color: var(--duco-blue);
							text-decoration: none;

							&::after {
								content: '\2192';
								margin-left: 5px;
							}
						}
					}
				}

				a {
					font-size: 24px;
					line-height: 30px;
					font-weight: 300;
					color: var(--duco-blue);
				}
			}

			.site_button {
				margin-top: 30px;
			}

			.gform_heading {
				display: none;
			}

			.gform-body {
				.ginput_container {
					input {
						appearance: none;
						border: 0;
						border-radius: 30px;
						font: normal normal normal 16px/24px var(--primary-font-family);
						padding: 20px 20px;
						background: transparent;
						color: var(--white);
						border: 1px solid var(--white);
					}
				}
			}

			.gform_footer {
				margin-top: 40px;

				@media (max-width: $mobile-xl) {
					margin-top: 24px;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/StayInTouch.vue